<template>
  <BCard no-body v-draggable class="popup text-dark">
    <BCardHeader
      style="height: 25px; user-select: none;"
      class="ps-2 pb-0 pt-0"
      header-tag="div"
    >
      <BRow class="mx-0 px-0">
        <BCol class="mx-0 px-0" cols="11">
          Auftrag {{action === 'edit' ? 'bearbeiten' : (action === 'create' ? 'erstellen' : 'kopieren')}}
          <FontAwesomeIcon 
            v-if="orderHistory"
            class="mx-2 clickable"
            icon="fa-solid fa-book"
            style="cursor:pointer;"
            @click="showHistory = !showHistory"
          />
        </BCol>
        <BCol class="mx-0 px-0" cols="1" style="display: flex; justify-content: end;">
          <div @click="$emit('close')">
            <FontAwesomeIcon
              class="mx-1 clickable"
              icon="fa-solid fa-xmark"
              style="cursor:pointer;"
            />            
          </div>
        </BCol>
      </BRow>
    </BCardHeader>

    <BForm id="order-edit-popup-form" @submit="onSubmit">
      <BCardBody id="order-edit-popup-card-body">
        <div v-if="showTransferPopup" style="position: absolute; width: 100%; height: 100%;"></div>
        <div class="toggle-collapse">
          <h5><b>Allgemeine Informationen</b></h5>
          <FontAwesomeIcon
            :class="'mx-1 clickable ' + (generalInformationVisible? '' : 'rotate180')"
            icon="fa-solid fa-angle-up"
            style="font-size: 20pt;"
            @click="(generalInformationVisible = !generalInformationVisible)"
          />
        </div>
        <BCollapse v-model="generalInformationVisible">
          <BRow>
            <BCol>
              <label for="input-project">Kunde/Projekt/Unterprojekt:</label>
              <treeselect 
                id="input-project"
                v-model="order.SubProjectId" 
                placeholder="Kunde/Projekt/Unterprojekt..."
                :options="clientProjectSubprojectList_treeselect"
                :loadOptions="null"
                :multiple="false"
                :disable-branch-nodes="true"
                :disabled="subProjectIdLocked"
                required
              />
            </BCol>
            <BCol>
              <label for="input-project">Projektmanager:</label>
              <treeselect 
                id="input-project-manager"
                v-model="order.ProjectManager" 
                placeholder="Projektmanager..."
                :options="projectManagerList"
                :loadOptions="null"
                :multiple="false"
                :disable-branch-nodes="true"
                required
              />
            </BCol>
          </BRow>
          <BRow class="mb-2">
            <BCol>
              <BFormGroup
                label="Auftragsname:"
                label-for="input-name"
              >
                <BFormInput
                  id="input-name"
                  v-model="order.OrderName"
                  type="text"
                  placeholder="Auftragsname..."
                  :state="orderNameAvailable"
                  @blur="getOrderNameAvailable()"
                  required
                ></BFormInput>
                <BFormInvalidFeedback id="input-name">
                  Name bereits vergeben.
                </BFormInvalidFeedback>
              </BFormGroup>
            </BCol>
            <BCol>
              <BRow>
                <BCol>
                  <BFormGroup
                    label="Startdatum:"
                    label-for="input-startDate"
                  >
                    <BFormInput
                      id="input-startDate"
                      v-model="order.StartDate"
                      type="date"
                      required
                    ></BFormInput>
                  </BFormGroup>
                </BCol>
                <BCol>
                  <BFormGroup
                    label="Enddatum:"
                    label-for="input-endDate"
                  >
                    <BFormInput
                      id="input-endDate"
                      v-model="order.EndDate"
                      type="date"
                      :state="states.inputEndDate"
                      required
                    ></BFormInput>
                    <BFormInvalidFeedback id="input-endDate">
                      {{ inputEndDateInvalidMsg }}
                    </BFormInvalidFeedback>
                  </BFormGroup>
                </BCol>
              </BRow>
            </BCol>
          </BRow>
        </BCollapse>
        <BTabs v-model:index="tabIndex" id="order-year-tabs">
          <!-- <template > -->
            <BTab 
              v-for="(orderYear, index_orderYear) in order.OrderYears" 
              :id="`order-year-tab-${orderYear.Year ?? index_orderYear}`"
              :key="`order-year-tab-${orderYear.Year ?? index_orderYear}`"
              :title="String(orderYear.Year)" 
            >
              <BButton
                v-if="index_orderYear != 0"
                class="my-2 transfer-button" 
                variant="outline-secondary"
                size="sm"
                pill
                @click="showTransferPopup = !showTransferPopup"
              >
                <FontAwesomeIcon
                  icon="fa-solid fa-copy"
                  style="font-size: 12pt;"
                />
                <span class="ms-2 transfer-span">Daten aus Vorjahr übernehmen</span>
              </BButton>
              <div class="toggle-collapse mt-3">
                <h5><b>Nachweise</b></h5>
                <FontAwesomeIcon
                  :class="'mx-1 clickable ' + (uploadsVisible? '' : 'rotate180')"
                  icon="fa-solid fa-angle-up"
                  style="font-size: 20pt;" 
                  @click="(uploadsVisible = !uploadsVisible)"
                />
              </div>
              <BCollapse v-model="uploadsVisible">
                <br>
                <BRow>
                <!-- FILES -->
                  <template v-for="(upload, index_upload) in orderYear.Uploads" :key="`upload-col-${index_upload}`">
                    <BCol cols="12" md="12" lg="4" class="upload-col">
                      <BFormGroup style="position: relative;">
                        <div class="upload-button-container">
                          <FontAwesomeIcon
                            :class="'mx-1 ' + (upload.UploadId ? 'clickable ' : 'disabled-color ')"
                            icon="fa-solid fa-download"
                            @click="openUpload(upload.UploadId)"
                          />
                          <FontAwesomeIcon
                            :class="'mx-1 ' + ((upload.UploadFile || upload.Name) ? 'clickable ' : 'disabled-color ')"
                            icon="fa-solid fa-trash"
                            @click="removeUpload(upload.UploadId, index_orderYear, index_upload)"
                          />
                        </div>
                        <BFormFile
                          :id="`order-upload-${index_orderYear}-${index_upload}`"
                          v-model="upload.UploadFile"
                          :placeholder="upload.Name || 'Keine Datei ausgewählt'"
                        ></BFormFile>
                      </BFormGroup>
                    </BCol>
                  </template>
                </BRow>
              </BCollapse>
              <hr>
              <!-- budget data -->
              <div class="toggle-collapse">
                <h5><b>Budgetplanung</b></h5>
                <FontAwesomeIcon
                  :class="'mx-1 clickable ' + (budgetDataVisible? '' : 'rotate180')"
                  icon="fa-solid fa-angle-up"
                  style="font-size: 20pt;" 
                  @click="(budgetDataVisible = !budgetDataVisible)"
                />
              </div>
              <BCollapse v-model="budgetDataVisible">
                <BRow v-if="orderYear.BudgetCategories && orderYear.BudgetCategories.length != 0">
                  <BCol cols="2"></BCol>
                  <BCol cols="3">Kommentar</BCol>
                  <BCol cols="2">Anzahl</BCol>
                  <BCol cols="2">Preis (€)</BCol>
                  <BCol cols="2">Gesamt (€)</BCol>
                  <BCol cols="1"></BCol>
                </BRow>
                <template v-for="(budgetCategory, index_budgetCategory) in orderYear.BudgetCategories" :key="`budget-cat-${index_budgetCategory}`">
                  <BRow class="my-1">
                    <BCol cols="2">
                      <b>{{index_budgetCategory + 1}}. {{getBudgetCategoryText(budgetCategory.BudgetCategoryId)}}</b>
                    </BCol>
                    <BCol cols="3">
                      <BFormInput
                        :id="`input-budgetCategory-comment-${index_budgetCategory}`"
                        v-model="budgetCategory.Comment"
                        type="text"
                        placeholder="Kommentar..."
                      ></BFormInput>
                    </BCol>
                    <BCol cols="2">
                      <BFormInput
                        :id="`input-budgetCategory-amount-${index_budgetCategory}`"
                        v-model="budgetCategory.Amount"
                        type="number"
                        placeholder="Anzahl..."
                        :step="1"
                        :min="0"
                        @update:model-value="calculateBudgetCategoryResult(budgetCategory), calculateBudget(orderYear), calculateSurveyInstancePriceMdatiqs(orderYear)"
                        required
                        :disabled="isBudgetCategoryDisabled(budgetCategory.BudgetCategoryId)"
                      ></BFormInput>
                    </BCol>
                    <BCol cols="2" style="position: relative;">
                      <span style="position: absolute; transform: translate(-20px, 4px);">×</span>
                      <BFormInput
                        :id="`input-budgetCategory-cost-${index_budgetCategory}`"
                        v-model="budgetCategory.Cost"
                        type="number"
                        placeholder="Preis..."
                        :step="0.01"
                        :min="0"
                        @update:model-value="calculateBudgetCategoryResult(budgetCategory), calculateBudget(orderYear), calculateSurveyInstancePriceMdatiqs(orderYear)"
                        required
                        :disabled="isBudgetCategoryDisabled(budgetCategory.BudgetCategoryId)"
                      ></BFormInput>
                    </BCol>
                    <BCol cols="2" style="position: relative;">
                      <span style="position: absolute; transform: translate(-20px, 4px);">=</span>
                      <BFormInput
                        :key="`input-budgetCategory-result-${index_budgetCategory}-${formChanges}`"
                        :id="`input-budgetCategory-result-${index_budgetCategory}`"
                        v-model="budgetCategory.Result"
                        type="number"
                        placeholder="..."
                        :step="0.01"
                        :min="0"
                        disabled
                      ></BFormInput>
                    </BCol>
                    <BCol cols="1" style="justify-content: center; display: flex;">
                      <BButton 
                        class="me-2" 
                        variant="outline-danger" 
                        @click="deleteBudgetCategory(budgetCategory, orderYear)"
                        :disabled="isBudgetCategoryDisabled(budgetCategory.BudgetCategoryId)"
                      >
                        <FontAwesomeIcon
                          class="mx-1 clickable"
                          icon="fa-solid fa-trash"
                          style="font-size: 14pt;"
                        />
                      </BButton>
                    </BCol>
                  </BRow>
                </template>
                <BRow>
                  <BCol cols="3" style="display: flex; justify-content: flex-start; align-items: center">
                    <FontAwesomeIcon
                      :class="'mx-2 clickable '"
                      icon="fa-solid fa-plus"
                      style="font-size: 20pt;" 
                      @click="addBudgetCategory(orderYear)"
                    />
                    <BFormSelect 
                      style="width: auto"
                      v-model="selectedBudgetCategoryId" 
                      :options="budgetCategories" 
                    ></BFormSelect>
                  </BCol>
                  <BCol cols="2"></BCol>
                  <BCol cols="2"></BCol>
                  <BCol cols="2"></BCol>
                  <BCol cols="2" style="position: relative;">
                    <hr v-if="orderYear.BudgetCategories && orderYear.BudgetCategories.length != 0">
                    <span style="position: absolute; transform: translate(-20px, 38px);">=</span>
                    <BFormGroup
                      label="Budget (€):"
                      :label-for="`input-budget-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-budget-${orderYear.Year}`"
                        v-model="orderYear.Budget"
                        type="number"
                        placeholder="Budget..."
                        :step="0.01"
                        :min="0"
                        disabled
                      ></BFormInput>
                    </BFormGroup>
                  </BCol>
                  <BCol cols="1"></BCol>
                </BRow>
                <br>
                <BRow>
                  <BCol>
                    <BFormGroup
                      label="Rückstellungen (€):"
                      :label-for="`input-reserve-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-reserve-${orderYear.Year}`"
                        v-model="orderYear.Reserve"
                        type="number"
                        placeholder="Rückstellungen..."
                        :step="0.01"
                        :min="0"
                        @update:model-value="value => setReserveOfFollowingYear(value, orderYear.Year)"
                        :disabled="!hasFollowingYear(orderYear.Year)"
                      ></BFormInput>
                    </BFormGroup>
                    <BFormGroup
                      label="Max. Durchschnittsvergütung pro Check (€):"
                      :label-for="`input-mappc-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-mappc-${orderYear.Year}`"
                        v-model="orderYear.MaxAveragePaymentPerCheck"
                        type="number"
                        placeholder="Max. Durchschnittsvergütung pro Check..."
                        :step="0.01"
                        :min="0"
                      ></BFormInput>
                    </BFormGroup>
                  </BCol>
                  <BCol>
                    <BFormGroup
                      label="Gemeinkosten-/Gewinnaufschlag (%):"
                      :label-for="`input-overheadcharge-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-overheadcharge-${orderYear.Year}`"
                        v-model="orderYear.OverheadCharge"
                        type="number"
                        placeholder="Gemeinkosten- und Gewinnaufschlag..."
                        :step="1"
                        :min="0"
                        :max="100"
                        @update:model-value="calculateOverheadCosts(orderYear), calculateMarketingCosts(orderYear), calculateDepartmentBudgets(orderYear)"
                        required
                      ></BFormInput>
                    </BFormGroup>
                    <BFormGroup
                      label="Gemeinkosten (€):"
                      :label-for="`input-overheadCosts-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-overheadCosts-${orderYear.Year}`"
                        v-model="orderYear.OverheadCosts"
                        type="number"
                        placeholder="Gemeinkosten..."
                        readonly
                        :step="0.01"
                        :min="0"
                      ></BFormInput>
                    </BFormGroup>
                  </BCol>
                  <BCol>
                    <BFormGroup
                      label="Vertriebsaufschlag (%):"
                      :label-for="`input-marketingcharge-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-marketingcharge-${orderYear.Year}`"
                        v-model="orderYear.MarketingCharge"
                        type="number"
                        placeholder="Vertriebsaufschlag..."
                        :step="1"
                        :min="0"
                        :max="100"
                        @update:model-value="calculateOverheadCosts(orderYear), calculateMarketingCosts(orderYear), calculateDepartmentBudgets(orderYear)"
                        required
                      ></BFormInput>
                    </BFormGroup>
                    <BFormGroup
                      label="Vertriebskosten (€):"
                      :label-for="`input-marketingCosts-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-marketingCosts-${orderYear.Year}`"
                        v-model="orderYear.MarketingCosts"
                        type="number"
                        placeholder="Gemeinkosten..."
                        readonly
                        :step="0.01"
                        :min="0"
                      ></BFormInput>
                    </BFormGroup>
                  </BCol>
                </BRow>
              </BCollapse>
              <hr>
              <div class="toggle-collapse">
                <h5><b>Fremdkosten</b></h5>
                <FontAwesomeIcon
                  :class="'mx-1 clickable ' + (externalCostsVisible? '' : 'rotate180')"
                  icon="fa-solid fa-angle-up"
                  style="font-size: 20pt;" 
                  @click="(externalCostsVisible = !externalCostsVisible)"
                />
              </div>
              <BCollapse v-model="externalCostsVisible">
                <BRow>
                  <BCol>
                    <BFormGroup
                      label="Fremdkosten MSM TK (€):"
                      :label-for="`input-externalCostsMsmTk-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-externalCostsMsmTk-${orderYear.Year}`"
                        v-model="orderYear.ExternalCostsMsmTk"
                        type="number"
                        placeholder="Fremdkosten MSM TK..."
                        :step="0.01"
                        :min="0"
                        @update:model-value="calculateOverheadCosts(orderYear), calculateMarketingCosts(orderYear), calculateDepartmentBudgets(orderYear)"
                        required
                      ></BFormInput>
                    </BFormGroup>
                    <BFormGroup
                      label="Fremdkosten Agentur (€):"
                      :label-for="`input-externalCostsAgency-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-externalCostsAgency-${orderYear.Year}`"
                        v-model="orderYear.ExternalCostsAgency"
                        type="number"
                        placeholder="Fremdkosten Agentur..."
                        :step="0.01"
                        :min="0"
                        @update:model-value="calculateOverheadCosts(orderYear), calculateMarketingCosts(orderYear), calculateDepartmentBudgets(orderYear)"
                        required
                      ></BFormInput>
                    </BFormGroup>
                  </BCol>
                  <BCol>
                    <BFormGroup
                      label="Fremdkosten BOLD (€):"
                      :label-for="`input-externalCostsMdatiqs-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-externalCostsMdatiqs-${orderYear.Year}`"
                        v-model="orderYear.ExternalCostsMdatiqs"
                        type="number"
                        placeholder="Fremdkosten BOLD..."
                        :step="0.01"
                        :min="0"
                        @update:model-value="calculateOverheadCosts(orderYear), calculateMarketingCosts(orderYear), calculateDepartmentBudgets(orderYear)"
                        required
                      ></BFormInput>
                    </BFormGroup>
                    <BFormGroup
                      label="Fremdkosten Sonstige (€):"
                      :label-for="`input-externalCostsOther-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-externalCostsOther-${orderYear.Year}`"
                        v-model="orderYear.ExternalCostsOther"
                        type="number"
                        placeholder="Fremdkosten Sonstige..."
                        :step="0.01"
                        :min="0"
                        @update:model-value="calculateOverheadCosts(orderYear), calculateMarketingCosts(orderYear), calculateDepartmentBudgets(orderYear)"
                        required
                      ></BFormInput>
                    </BFormGroup>
                  </BCol>
                  <BCol>
                    <BFormGroup
                      label="Checkpreis BOLD 2€ pro Check (€):"
                      :label-for="`input-surveyInstancePriceMdatiqs-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-surveyInstancePriceMdatiqs-${orderYear.Year}`"
                        v-model="orderYear.SurveyInstancePriceMdatiqs"
                        type="number"
                        placeholder="Checkpreis BOLD..."
                        :step="1"
                        :min="0"
                        disabled
                      ></BFormInput>
                    </BFormGroup>
                  </BCol>
                </BRow>
              </BCollapse>
              <hr>
              <div class="toggle-collapse">
                <h5><b>Abteilungsbudgets</b></h5>
                <FontAwesomeIcon
                  :class="'mx-1 clickable ' + (departmentBudgetsVisible? '' : 'rotate180')"
                  icon="fa-solid fa-angle-up"
                  style="font-size: 20pt;" 
                  @click="(departmentBudgetsVisible = !departmentBudgetsVisible)"
                />
              </div>
              <BCollapse v-model="departmentBudgetsVisible">
                <BRow>
                  <BCol>
                    <p>Verfügbares Abteilungsbudget: <b :class="(departmentBudget >= 0 ? 'black' : 'red')">{{ formatMoneyValue(departmentBudget) }}€</b></p> 
                    <p>Verteiltes Abteilungsbudget: <b :class="(distributedDepartmentBudget <= 100 ? 'black' : 'red')">{{ distributedDepartmentBudget }}%</b></p>
                  </BCol>
                </BRow>
                <BRow>
                  <BCol>
                    <BFormGroup
                      label="Budget Feld (%):"
                      :label-for="`input-budgetField_percentage-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-budgetField_percentage-${orderYear.Year}`"
                        v-model="orderYear.BudgetField_percentage"
                        type="number"
                        placeholder="Budget Feld..."
                        :step="1"
                        :max="100"
                        :min="0"
                        @update:model-value="calculateDepartmentBudgets(orderYear)"
                      ></BFormInput>
                    </BFormGroup>
                    <BFormGroup
                      label="Budget Feld (€):"
                      :label-for="`input-budgetField-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-budgetField-${orderYear.Year}`"
                        v-model="orderYear.BudgetField"
                        type="number"
                        placeholder="Budget Feld..."
                        :step="0.01"
                        :min="0"
                        disabled
                      ></BFormInput>
                    </BFormGroup>
                  </BCol>
                  <BCol>
                    <BFormGroup
                      label="Budget Projektmanagement (%):"
                      :label-for="`input-budgetProjectManagement_percentage-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-budgetProjectManagement_percentage-${orderYear.Year}`"
                        v-model="orderYear.BudgetProjectManagement_percentage"
                        type="number"
                        placeholder="Budget Projektmanagement..."
                        :step="1"
                        :max="100"
                        :min="0"
                        @update:model-value="calculateDepartmentBudgets(orderYear)"
                      ></BFormInput>
                    </BFormGroup>
                    <BFormGroup
                      label="Budget Projektmanagement (€):"
                      :label-for="`input-budgetProjectManagement-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-budgetProjectManagement-${orderYear.Year}`"
                        v-model="orderYear.BudgetProjectManagement"
                        type="number"
                        placeholder="Budget Projektmanagement..."
                        :step="0.01"
                        :min="0"
                        disabled
                      ></BFormInput>
                    </BFormGroup>
                  </BCol>
                  <BCol>
                    <BFormGroup
                      label="Budget Qualitätssicherung (%):"
                      :label-for="`input-budgetQualityAssurance_percentage-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-budgetQualityAssurance_percentage-${orderYear.Year}`"
                        v-model="orderYear.BudgetQualityAssurance_percentage"
                        type="number"
                        placeholder="Budget Qualitätssicherung..."
                        :step="1"
                        :max="100"
                        :min="0"
                        @update:model-value="calculateDepartmentBudgets(orderYear)"
                      ></BFormInput>
                    </BFormGroup>
                    <BFormGroup
                      label="Budget Qualitätssicherung (€):"
                      :label-for="`input-budgetQualityAssurance-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-budgetQualityAssurance-${orderYear.Year}`"
                        v-model="orderYear.BudgetQualityAssurance"
                        type="number"
                        placeholder="Budget Qualitätssicherung..."
                        :step="0.01"
                        :min="0"
                        disabled
                      ></BFormInput>
                    </BFormGroup>
                  </BCol>
                </BRow>
              </BCollapse>
              <hr>
              <div class="toggle-collapse">
                <h5><b>Abweichende Rechnungsadresse Auftrag</b></h5>
                <FontAwesomeIcon
                  :class="'mx-1 clickable ' + (billToVisible? '' : 'rotate180')"
                  icon="fa-solid fa-angle-up"
                  style="font-size: 20pt;" 
                  @click="(billToVisible = !billToVisible)"
                />
              </div>
              <BCollapse v-model="billToVisible">
                <BRow>
                  <BCol>
                    <BFormGroup
                      label="Rechnungsempfänger:"
                      :label-for="`input-billTo-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-billTo-${orderYear.Year}`"
                        v-model="orderYear.BillTo"
                        type="text"
                        placeholder="Rechnungsempfänger..."
                      ></BFormInput>
                    </BFormGroup>
                    <BFormGroup
                      label="Adresse:"
                      :label-for="`input-billingAddress-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-billingAddress-${orderYear.Year}`"
                        v-model="orderYear.BillingAddress"
                        type="text"
                        placeholder="Adresse..."
                      ></BFormInput>
                    </BFormGroup>
                    <BFormGroup
                      label="Ort:"
                      :label-for="`input-billingCity-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-billingCity-${orderYear.Year}`"
                        v-model="orderYear.BillingCity"
                        type="text"
                        placeholder="Ort..."
                      ></BFormInput>
                    </BFormGroup>
                    <BFormGroup
                      label="E-Mail-Adresse Mahnung:"
                      :label-for="`input-email-payment-reminder-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-email-payment-reminder-${orderYear.Year}`"
                        v-model="orderYear.BillingEmailPaymentReminder"
                        type="email"
                        placeholder="E-Mail-Adresse Mahnung..."
                      ></BFormInput>
                    </BFormGroup>
                  </BCol>
                  <BCol>
                    <BFormGroup
                      label="Land:"
                      :label-for="`input-billingCountry-${orderYear.Year}`"
                    >
                      <BFormSelect
                        :id="`input-billingCountry-${orderYear.Year}`"
                        v-model="orderYear.BillingCountry"
                        :options="countryList"
                        placeholder="Land..."
                      ></BFormSelect>
                    </BFormGroup>
                    <BFormGroup
                      label="Postleitzahl:"
                      :label-for="`input-billingPostalCode-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-billingPostalCode-${orderYear.Year}`"
                        v-model="orderYear.BillingPostalCode"
                        type="text"
                        placeholder="Postleitzahl..."
                      ></BFormInput>
                    </BFormGroup>
                    <BFormGroup
                      label="E-Mail-Adresse:"
                      :label-for="`input-email-${orderYear.Year}`"
                    >
                      <BFormInput
                        :id="`input-email-${orderYear.Year}`"
                        v-model="orderYear.BillingEmail"
                        type="email"
                        placeholder="E-Mail-Adresse..."
                      ></BFormInput>
                    </BFormGroup>
                  </BCol>
                </BRow>
              </BCollapse>
            </BTab>
          <!-- </template> -->
        </BTabs>
      </BCardBody>
      <BCardFooter id="order-edit-popup-card-footer">
        <BRow>
          <BCol v-if="order.OrderYears[tabIndex]" cols="9" style="display: flex; align-items: center; font-size: 14pt; font-weight: bold;">
            <BButton class="me-2" variant="outline-danger" @click="showDeletePopup = true" v-if="action === 'edit'">
              <FontAwesomeIcon
                class="mx-1 clickable"
                icon="fa-solid fa-trash"
                style="font-size: 14pt;"
              />
              <span>Löschen</span>
            </BButton>
            <span class="mx-2">Budget nach Auftrag: {{formatMoneyValue(order.OrderYears[tabIndex].Budget)}}€</span>
            <span class="mx-2">Verplantes Budget: {{formatMoneyValue(usedBudget)}}€</span>
            <span class="mx-2">Differenz: <span :class="((order.OrderYears[tabIndex]?.Budget - usedBudget) >= 0 ? 'green' : 'red')">{{formatMoneyValue(order.OrderYears[tabIndex]?.Budget - usedBudget)}}€</span></span>
          </BCol>
          <BCol style="text-align:end">
            <BButton class="m-2" type="submit" variant="primary" :disabled="formChanges === 0 || orderNameAvailable === false">Speichern</BButton>
            <BButton class="m-2" @click="$emit('close')" variant="secondary">Abbrechen</BButton>
          </BCol>
        </BRow>
      </BCardFooter>
    </BForm>

    <!-- History Popup -->
    <GenericPopup v-if="showHistory" @close="showHistory = false" width="50vw" max-height="50vh">
      <div v-for="(e, index) in orderHistory" :key="index">
        {{e.FirstName}} {{e.LastName}} {{e.Timestamp}}: 
        <br>
        <span v-html="displayHistoryElement(e.OrderJson, index)"></span>
        <hr>
      </div>
    </GenericPopup>

    <!-- Delete Popup -->
    <GenericPopup v-if="showDeletePopup" @close="showDeletePopup = false" width="25vw">
      <BCol>
        <BRow style="display: flex;justify-content: center;text-align: center;">
          <span v-if="!order.HasSalary">Soll das Unterprojekt gelöscht werden?</span>
          <span v-else-if="order.HasSalary">
            Es gibt Zeiteinträge für diesen Auftrag.
            <br> Er kann nicht gelöscht werden.
          </span>
        </BRow>
        <BRow style="display: flex;justify-content: center; align-items:center">
          <FontAwesomeIcon 
            v-if="order.HasSalary"
            class="mx-2"
            icon="fa-solid fa-lock"
          />
          <BButton class="m-2" variant="danger" @click="setOrderInactive()" :disabled="order.HasSalary">Löschen</BButton>
          <BButton class="m-2" @click="showDeletePopup = false" >Abbrechen</BButton>
        </BRow>
      </BCol>
    </GenericPopup>

    <!-- Transfer Popup -->
    <GenericPopup v-if="showTransferPopup" @close="showTransferPopup = false" width="20vw">
      <BCol>
        <BRow>Daten aus {{order.OrderYears[this.tabIndex - 1].Year}} in {{order.OrderYears[this.tabIndex].Year}} übernehmen:</BRow>
        <BRow class="mt-2">
          <BCol>
            <BFormCheckbox 
              v-for="(option, index) in transferOptions"
              v-bind:key="index"
              v-model="option.value"
            >{{option.name}}</BFormCheckbox>
          </BCol>
        </BRow>
        <BRow class="mt-2" style="display: flex;justify-content: center;">
          <BButton class="m-2" variant="danger" @click="transferFromPreviousYear()">Übernehmen</BButton>
          <BButton class="m-2" @click="showTransferPopup = false" >Abbrechen</BButton>
        </BRow>
      </BCol>
    </GenericPopup>
  </BCard>
</template>

<script>
import AuthenticationService from '../services/AuthenticationService';
import ControllingService from '../services/ControllingService';
import UploadService from '../services/UploadService';
import UsersService from '../services/UsersService';

import Treeselect from '@zanmato/vue3-treeselect'
import GenericPopup from './GenericPopup';

const UPLOAD_TEMPLATE = {
  Name: null,
  UploadFile: null,
  DataURI: null
};
const ORDER_YEAR_TEMPLATE = {
  "Year":null,
  "OrderId":null,
  "Reserve":0,
  "PlannedSurveyInstanceNumber":0,
  "SurveyInstancePrice":0,
  "Budget":0,
  "OverheadCharge":0,
  "OverheadCosts":0,
  "MarketingCharge":0,
  "MarketingCosts":0,
  "ExternalCostsMsmTk":0,
  "ExternalCostsAgency":0,
  "ExternalCostsOther":0,
  "ExternalCostsMdatiqs":0,
  "SurveyInstancePriceMdatiqs":0,
  "BudgetField":0,
  "BudgetField_percentage":0,
  "BudgetProjectManagement":0,
  "BudgetProjectManagement_percentage":null,
  "BudgetQualityAssurance":0,
  "BudgetQualityAssurance_percentage":null,
  "BillTo":null,
  "BillingAddress":null,
  "BillingCity":null,
  "BillingCountry":null,
  "BillingPostalCode":null,
  "BillingEmail":null,
  "BillingEmailPaymentReminder": null,
  "ThirdPartyServices":null,
  "AllocationOfOverheadCosts":null,
  "Uploads": []
};

export default {
  name: "OrderEditPopup",
  emits: ['close', 'close-reload'],
  components: {
    Treeselect,
    GenericPopup
  },
  props: {
    clientProjectSubprojectList_treeselect: {
      type: Array,
      default: () => []
    },
    action: {
      type: String,
      default: null
    },
    selectedOrder: {
      type: Object,
      default: null
    },
    selectedSubproject: {
      type: Object,
      default: null
    },
    budgetCategories: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      budgetDataVisible: true,
      countryList: null,
      formChanges: 0,
      generalInformationVisible: true,
      inputEndDateInvalidMsg: null,
      order: {
        "OrderId": null,
        "SubProjectId": null,
        "OrderName": null,
        "StartDate": null,
        "EndDate": null,
        "ProjectManager": null,
        "OrderYears": []
      },
      orderHistory: null,
      orderNameAvailable: null,
      showDeletePopup: false,
      showHistory: false,
      showTransferPopup: false,
      subProjectIdLocked: false,
      states: {
        inputEndDate: null,
      },
      tabIndex: null,
      transferOptions: {
        files: {
          name: "Nachweise",
          value: false
        },
        budget: {
          name: "Budgetplanung",
          value: false
        },
        costs: {
          name: "Fremdkosten",
          value: false
        },
        department: {
          name: "Abteilungsbudgets",
          value: false
        },
        address: {
          name: "Abweichende Rechnungsadresse Auftrag",
          value: false
        },
      },
      uploadsToBeDeleted: [],

      billToVisible: false,
      departmentBudgetsVisible: true,
      externalCostsVisible: true,
      uploadsVisible: true,
      selectedBudgetCategoryId: null,
      projectManagerList: null
    }
  },
  watch: {
    order: {
      handler() {
        this.formChanges++;
      },
      deep: true
    },
    'order.StartDate'() {
      this.applyOrderYears();
    },
    'order.EndDate'() {
      this.applyOrderYears();
    },
  },
  computed: {
    usedBudget() {
      if(!this.order.OrderYears[this.tabIndex]) return null;
      var res = (
          (this.order.OrderYears[this.tabIndex].Reserve ? Number(this.order.OrderYears[this.tabIndex].Reserve) : 0)
        + (this.order.OrderYears[this.tabIndex].OverheadCosts ? Number(this.order.OrderYears[this.tabIndex].OverheadCosts) : 0)
        + (this.order.OrderYears[this.tabIndex].MarketingCosts ? Number(this.order.OrderYears[this.tabIndex].MarketingCosts) : 0)
        + (this.order.OrderYears[this.tabIndex].ExternalCostsMsmTk ? Number(this.order.OrderYears[this.tabIndex].ExternalCostsMsmTk) : 0)
        + (this.order.OrderYears[this.tabIndex].ExternalCostsAgency ? Number(this.order.OrderYears[this.tabIndex].ExternalCostsAgency) : 0)
        + (this.order.OrderYears[this.tabIndex].ExternalCostsOther ? Number(this.order.OrderYears[this.tabIndex].ExternalCostsOther) : 0)
        + (this.order.OrderYears[this.tabIndex].ExternalCostsMdatiqs ? Number(this.order.OrderYears[this.tabIndex].ExternalCostsMdatiqs) : 0)
        + (this.order.OrderYears[this.tabIndex].SurveyInstancePriceMdatiqs ? Number(this.order.OrderYears[this.tabIndex].SurveyInstancePriceMdatiqs) : 0)
        + (this.order.OrderYears[this.tabIndex].BudgetField ? Number(this.order.OrderYears[this.tabIndex].BudgetField) : 0)
        + (this.order.OrderYears[this.tabIndex].BudgetProjectManagement ? Number(this.order.OrderYears[this.tabIndex].BudgetProjectManagement) : 0)
        + (this.order.OrderYears[this.tabIndex].BudgetQualityAssurance ? Number(this.order.OrderYears[this.tabIndex].BudgetQualityAssurance) : 0)
      )
      return res;
    },
    departmentBudget() {
      if(!this.order.OrderYears[this.tabIndex]) return null;
      var res = (
        (this.order.OrderYears[this.tabIndex].Budget ? Number(this.order.OrderYears[this.tabIndex].Budget) : 0)
        - (this.order.OrderYears[this.tabIndex].Reserve ? Number(this.order.OrderYears[this.tabIndex].Reserve) : 0)
        - (this.order.OrderYears[this.tabIndex].OverheadCosts ? Number(this.order.OrderYears[this.tabIndex].OverheadCosts) : 0)
        - (this.order.OrderYears[this.tabIndex].MarketingCosts ? Number(this.order.OrderYears[this.tabIndex].MarketingCosts) : 0)
        - (this.order.OrderYears[this.tabIndex].ExternalCostsMsmTk ? Number(this.order.OrderYears[this.tabIndex].ExternalCostsMsmTk) : 0)
        - (this.order.OrderYears[this.tabIndex].ExternalCostsAgency ? Number(this.order.OrderYears[this.tabIndex].ExternalCostsAgency) : 0)
        - (this.order.OrderYears[this.tabIndex].ExternalCostsOther ? Number(this.order.OrderYears[this.tabIndex].ExternalCostsOther) : 0)
        - (this.order.OrderYears[this.tabIndex].ExternalCostsMdatiqs ? Number(this.order.OrderYears[this.tabIndex].ExternalCostsMdatiqs) : 0)
        - (this.order.OrderYears[this.tabIndex].SurveyInstancePriceMdatiqs ? Number(this.order.OrderYears[this.tabIndex].SurveyInstancePriceMdatiqs) : 0)
      )
      return res;
    },
    distributedDepartmentBudget() {
      if(!this.order.OrderYears[this.tabIndex]) return null;
      return (
        parseInt(this.order.OrderYears[this.tabIndex].BudgetField_percentage ? this.order.OrderYears[this.tabIndex].BudgetField_percentage : 0) + 
        parseInt(this.order.OrderYears[this.tabIndex].BudgetProjectManagement_percentage ? this.order.OrderYears[this.tabIndex].BudgetProjectManagement_percentage : 0) + 
        parseInt(this.order.OrderYears[this.tabIndex].BudgetQualityAssurance_percentage ? this.order.OrderYears[this.tabIndex].BudgetQualityAssurance_percentage : 0)
      );
    },
  }, 
  mounted() {
    this.getProjectManagerList();

    ControllingService.getCountryList()
    .then(res => {
      this.countryList = res.data;
      
      // unshift placeholder
      this.countryList.unshift({ value: null, text: 'Land...', disabled: true})
    });

    // set subproject if probability is 100
    if(this.selectedSubproject?.Probability === 100) {
      this.order.SubProjectId = this.selectedSubproject.SubProjectId;
    }

    // set default dates
    this.order.StartDate = new Date().getFullYear() + '-01-01';
    this.order.EndDate = new Date().getFullYear() + '-12-31';
    
    if(this.selectedOrder && this.action === 'edit'){
      this.order = JSON.parse(JSON.stringify(this.selectedOrder));

      this.order.OrderYears.forEach(orderYear => {
        if(!orderYear.Uploads) orderYear.Uploads = [];
        let index = orderYear.Uploads.length;
        for (index; index < 3; index++) {
          orderYear.Uploads.push(JSON.parse(JSON.stringify(UPLOAD_TEMPLATE)))
        }
      });

      if(this.order.SubProjectId) {
        this.subProjectIdLocked = true;
      }

      // get Order History
      if(this.hasPermission('Management')) {
        ControllingService.getOrderHistory(this.selectedOrder.OrderId)
        .then(res => {
          if(res.data) {
            this.orderHistory = res.data;
          }
        });
      }
    };

    if(this.selectedOrder && this.action === 'copy'){
      this.order.SubProjectId = this.selectedOrder.SubProjectId
      this.order.OrderName = (this.selectedOrder.OrderName + ' - KOPIE');
      this.order.StartDate = this.selectedOrder.StartDate
      this.order.EndDate = this.selectedOrder.EndDate
      this.order.OrderYears = this.selectedOrder.OrderYears
      this.order.OrderYears.forEach(oy => {
        oy.Uploads = [];
        for (let index = 0; index < 3; index++) {
          oy.Uploads.push(JSON.parse(JSON.stringify(UPLOAD_TEMPLATE)))
        }
      });

      if(this.order.SubProjectId) {
        this.subProjectIdLocked = true;
      }
    };

    // wait for all to be mounted
    setTimeout(() => {
      this.tabIndex = this.order.OrderYears?.length - 1;

      this.formChanges = 0;
      if(this.action === 'copy') this.formChanges++;
    }, 100);
  },
  methods: {
    isBudgetCategoryDisabled(budgetCategoryId) {
      let bc = this.budgetCategories.find(e => e.value === budgetCategoryId);
      if(!bc) return true;
      return bc.disabled;
    },
    calculateBudgetCategoryResult(budgetCategory) {
      if(!budgetCategory || !budgetCategory.Amount || !budgetCategory.Cost) return;
      budgetCategory.Result = (budgetCategory.Amount * budgetCategory.Cost).toFixed(2);
    },
    setReserveOfFollowingYear(value, year){
      if(!this.hasFollowingYear(year)) return;

      let orderYear = this.order.OrderYears.find(x => x.Year === (year + 1));
      let cat = this.budgetCategories.find(e => e.text === "Rückstellungen");

      if(!orderYear.BudgetCategories) orderYear.BudgetCategories = [];
      let bc = orderYear.BudgetCategories.find(e => e.BudgetCategoryId === cat.value);
      if(!bc) orderYear.BudgetCategories.push({Amount: 1, BudgetCategoryId: cat.value, Cost: value});
      else bc.Cost = value;
      this.calculateBudgetCategoryResult(bc);

      if(!value) {
        orderYear.BudgetCategories = orderYear.BudgetCategories.filter(x => x != bc);
      }

      this.calculateBudget(orderYear);
      this.calculateSurveyInstancePriceMdatiqs(orderYear);
    },
    hasFollowingYear(year) {
      if(!this.order.OrderYears || this.order.OrderYears.length < 1) return false;
      let followingYear = this.order.OrderYears.find(x => x.Year === (year + 1));
      return !!followingYear;      
    },
    getProjectManagerList() {
      UsersService.getUserOfPermissionList("AllocationAsProjectManager")
        .then(res => {
          if(res.data) this.projectManagerList = res.data;
        })
    },
    addBudgetCategory(orderYear) {
      if(!this.selectedBudgetCategoryId) return;
      let cat = this.budgetCategories.find(e => e.value === this.selectedBudgetCategoryId);
      if(!orderYear.BudgetCategories) orderYear.BudgetCategories = [];
      orderYear.BudgetCategories.push({Amount: 1, BudgetCategoryId: cat.value, Cost: 0});
      this.selectedBudgetCategoryId = null;

      this.calculateBudget(orderYear);
      this.calculateSurveyInstancePriceMdatiqs(orderYear);
    },
    applyOrderYears() {
      if (!this.order.StartDate || !this.order.EndDate) {
        return;
      }
      const years = [];
      const startYear = new Date(Date.parse(this.order.StartDate)).getFullYear();
      const endYear = new Date(Date.parse(this.order.EndDate)).getFullYear();

      for (let year = startYear; year <= endYear; year++) {
          years.push(year);
      }
      years.forEach(year => {
        var hasYear = false;
        for (let index = 0; index < this.order.OrderYears.length; index++) {
          const orderYear = this.order.OrderYears[index];
          if(orderYear?.Year == year) {
            hasYear = true;
          }
        };
        if(!hasYear) {
          var newOrderYear = JSON.parse(JSON.stringify(ORDER_YEAR_TEMPLATE));
          newOrderYear.Year = year;
          for (let index = 0; index < 3; index++) {
            newOrderYear.Uploads.push(JSON.parse(JSON.stringify(UPLOAD_TEMPLATE)))
          }
          this.order.OrderYears.push(newOrderYear)
        }
      });

      // delete orderYears when not in new year range
      for (let index = 0; index < this.order.OrderYears.length; index++) {
        const orderYear = this.order.OrderYears[index];
        if(!years.includes(orderYear.Year)) {
          delete this.order.OrderYears[index];
        }
      }
      this.order.OrderYears = this.order.OrderYears.filter(oy => oy != undefined );
    },
    calculateBudget(orderYear) {
      let budget = 0;
      if(orderYear.BudgetCategories) {
        orderYear.BudgetCategories.forEach(cat => {
          budget += parseFloat(((cat.Cost ? cat.Cost : 0 ) * (cat.Amount ? cat.Amount : 0)).toFixed(2));
        });
      }
      orderYear.Budget = budget.toFixed(2);

      this.calculateOverheadCosts(orderYear);
      this.calculateMarketingCosts(orderYear);
      this.calculateDepartmentBudgets(orderYear);
    },
    calculateDepartmentBudgets(orderYear) {
      orderYear.BudgetField = (this.departmentBudget * (orderYear.BudgetField_percentage / 100)).toFixed(2);
      orderYear.BudgetProjectManagement = (this.departmentBudget * (orderYear.BudgetProjectManagement_percentage / 100)).toFixed(2);
      orderYear.BudgetQualityAssurance = (this.departmentBudget * (orderYear.BudgetQualityAssurance_percentage / 100)).toFixed(2);
    },
    calculateMarketingCosts(orderYear) {
      orderYear.MarketingCosts = ((orderYear?.Budget - orderYear?.Reserve) * (orderYear?.MarketingCharge / 100)).toFixed(2);
    },
    calculateOverheadCosts(orderYear) {
      orderYear.OverheadCosts = ((orderYear?.Budget - orderYear?.Reserve) * (orderYear?.OverheadCharge / 100)).toFixed(2);
    },
    calculateSurveyInstancePriceMdatiqs(orderYear) {
      let budgetCategory_Checks_Id = this.budgetCategories.find(e => e.text === "Checks")?.value;
      if(!budgetCategory_Checks_Id) return;
      let plannedSurveyInstanceNumber = 0;
      if(orderYear.BudgetCategories) {
        orderYear.BudgetCategories.forEach(cat => {
          if(cat.BudgetCategoryId === budgetCategory_Checks_Id) plannedSurveyInstanceNumber += parseFloat(cat.Amount);
        });
      };

      orderYear.SurveyInstancePriceMdatiqs = plannedSurveyInstanceNumber * 2;
    },
    deleteBudgetCategory(budgetCategory, orderYear) {
      orderYear.BudgetCategories = orderYear.BudgetCategories.filter(cat => cat != budgetCategory);
      this.calculateBudget(orderYear);
      this.formChanges++;
    },
    async deleteUploads() {
      const deletePromises = this.uploadsToBeDeleted.map(uploadId => {
        return UploadService.deleteUpload(uploadId);
      });

      await Promise.all(deletePromises);
    },
    displayHistoryElement(OrderJson, index){
      if(index == this.orderHistory.length - 1) return this.formatJson(OrderJson);
      var historyJsonBefore = this.orderHistory[index + 1].OrderJson;
      var newJson = this.findJsonDifferences(historyJsonBefore, OrderJson);
      return this.formatJson(newJson);
    },
    formatJson(jsonString) {
      var formattedJson = JSON.stringify(jsonString, null, 4);
      return formattedJson.replace(/ /g, '&nbsp;').replace(/\n/g, '<br>');
    },
    formatMoneyValue(value) {
      if(!value) return 0;
      var isNegative = false;
      var output = null;
      var indexOfPoint = value.toString().indexOf('.');
      var number;
      var res;

      if(indexOfPoint != -1) {
        number = value.toString().substring(0, indexOfPoint);
      } else {
        number = value.toString();
      }
      if(number < 0) {
        isNegative = true;
        number = number * (-1);
      }
      if (number.length > 3) {
        var mod = number.length % 3;
        var output = (mod > 0 ? (number.substring(0,mod)) : '');
        for (var i = 0 ; i < Math.floor(number.length / 3); i++) {
          if ((mod == 0) && (i == 0))
            output += number.substring(mod + 3 * i, mod + 3 * i + 3);
          else
            output += '.' + number.substring(mod + 3 * i, mod + 3 * i + 3);
        }
        res = output;
      }
      else {
        res = number;
      }
      // append decimals
      if(indexOfPoint != -1) {
        var decimals = value.toString().substring(indexOfPoint);
        res = res + ',' + decimals.substring(1,3);
        if(decimals.length < 3) {
          res = res + '0'
        }
      } else {
        res = res + ',00';
      }
      if(isNegative) {
        res = '-' + res;
      }
      return res;
    },
    findJsonDifferences(oldJson, newJson) {
      try {
        const diffJson = {};

        for (const key in newJson) {
          if (key === 'OrderYears') {
            // Always include the "OrderYears" array, even if there are no differences
            diffJson[key] = newJson[key].map((yearObj, index) => {
              const oldYearObj = oldJson[key] && oldJson[key][index];

              const yearDiff = {
                'Year': yearObj['Year'],
              };

              for (const subKey in yearObj) {
                if(!oldYearObj) {
                  yearDiff[subKey] = yearObj[subKey];
                } else if (yearObj[subKey] !== oldYearObj[subKey]) {
                  yearDiff[subKey] = yearObj[subKey];
                }
              }

              return Object.keys(yearDiff).length > 1 ? yearDiff : { 'Year': yearObj['Year'] };
            });
          } else if (typeof newJson[key] === 'object' && !Array.isArray(newJson[key])) {
            if (oldJson[key]) {
              const nestedDiff = this.findJsonDifferences(oldJson[key], newJson[key]);
              if (Object.keys(nestedDiff).length > 0) {
                diffJson[key] = nestedDiff;
              }
            } else {
              diffJson[key] = newJson[key];
            }
          } else if (Array.isArray(newJson[key])) {
            if (oldJson[key] && Array.isArray(oldJson[key]) && oldJson[key].length === newJson[key].length) {
              const arrayDiff = [];
              for (let i = 0; i < newJson[key].length; i++) {
                const nestedDiff = this.findJsonDifferences(oldJson[key][i], newJson[key][i]);
                if (Object.keys(nestedDiff).length > 0) {
                  arrayDiff.push(nestedDiff);
                }
              }
              if (arrayDiff.length > 0) {
                diffJson[key] = arrayDiff;
              }
            } else {
              diffJson[key] = newJson[key];
            }
          } else {
            if (oldJson[key] !== newJson[key]) {
              diffJson[key] = newJson[key];
            }
          }
        }

        return diffJson;
      } catch (error) {
        console.error('Error parsing JSON:', error);
        return null; // Return null if parsing fails
      }
    },
    formatterConsultant(value) {
      let threeChars = /^[a-zA-Z]{3}$/;
      let twoChars = /^[a-zA-Z]{2}$/;

      if(threeChars.test(value)) return value;
      if(twoChars.test(value)) return value;
      
      return '';
    },
    getOrderNameAvailable() {
      if(this.formChanges > 0 && this.order.SubProjectId && this.order.OrderName) {
        ControllingService.getOrderNameAvailable({SubProjectId: this.order.SubProjectId, OrderId: this.order.OrderId, OrderName: this.order.OrderName})
        .then(res => {
          if(!res.data.OrderNameAvailable) {
            this.orderNameAvailable = false;
          } else {
            this.orderNameAvailable = null;
          }
        })
      }
    },
    getBudgetCategoryText(budgetCategoryId) {
      let cat = this.budgetCategories.find(e => e.value === budgetCategoryId);
      if(cat?.text) return cat.text;
      return null;
    },
    hasPermission(permission) {
      return AuthenticationService.hasPermission(permission);
    },
    async onSubmit(event) {
      event.preventDefault();
      var isValid = this.validateOrder();
      if(!isValid) return;

      ControllingService.setOrder(this.order)
      .then(async (res) => {
        await this.deleteUploads();
        await this.uploadFiles(res.data.OrderId);
        this.$emit('close-reload');
      });
    },
    openUpload(uploadId) {
      if(!uploadId) return;
      UploadService.getUpload(uploadId)
      .then(res => {
        UploadService.openDataURI(res.data.DataURI);
      })
    },
    removeUpload(UploadId, index_orderYear, index_upload) {
      try {
        if(UploadId) {
          this.uploadsToBeDeleted.push(UploadId);
        }

        // create new uploads array to force rerender of upload inputs and its placeholders
        const oldUploads = this.order.OrderYears[index_orderYear].Uploads;
        this.order.OrderYears[index_orderYear].Uploads = [];
        for (let index = 0; index < 3; index++) {
          if(index != index_upload) {
            this.order.OrderYears[index_orderYear].Uploads.push(oldUploads[index]);
          } else {
            this.order.OrderYears[index_orderYear].Uploads.push(JSON.parse(JSON.stringify(UPLOAD_TEMPLATE)));
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    setOrderInactive() {
      ControllingService.setOrderInactive(this.order.OrderId)
      .then(() => {
        this.$emit('close-reload');
      })
    },
    transferFromPreviousYear() {
      if(this.transferOptions.files.value) {
        this.order.OrderYears[this.tabIndex].Uploads.forEach(u => {
          if(u.UploadId) this.uploadsToBeDeleted.push(u.UploadId);
        })
        this.order.OrderYears[this.tabIndex].Uploads = JSON.parse(JSON.stringify(this.order.OrderYears[this.tabIndex - 1].Uploads));
        this.order.OrderYears[this.tabIndex].Uploads.forEach(upload => {
          if(upload.UploadId && upload.Name && upload.OrderId) {
            UploadService.getUpload(upload.UploadId)
            .then(res => {
              upload.Year = this.order.OrderYears[this.tabIndex].Year;
              upload.DataURI = res.data.DataURI;
            });
          }
        });
      }
      if(this.transferOptions.budget.value) {
        this.order.OrderYears[this.tabIndex].BudgetCategories = structuredClone(this.order.OrderYears[this.tabIndex - 1].BudgetCategories);
        this.order.OrderYears[this.tabIndex].SurveyInstancePrice = this.order.OrderYears[this.tabIndex - 1].SurveyInstancePrice;
        this.order.OrderYears[this.tabIndex].Reserve = this.order.OrderYears[this.tabIndex - 1].Reserve;
        this.order.OrderYears[this.tabIndex].OverheadCharge = this.order.OrderYears[this.tabIndex - 1].OverheadCharge;
        this.order.OrderYears[this.tabIndex].MarketingCharge = this.order.OrderYears[this.tabIndex - 1].MarketingCharge;
      }
      if(this.transferOptions.costs.value) {
        this.order.OrderYears[this.tabIndex].ExternalCostsMsmTk = this.order.OrderYears[this.tabIndex - 1].ExternalCostsMsmTk;
        this.order.OrderYears[this.tabIndex].ExternalCostsAgency = this.order.OrderYears[this.tabIndex - 1].ExternalCostsAgency;
        this.order.OrderYears[this.tabIndex].ExternalCostsMdatiqs = this.order.OrderYears[this.tabIndex - 1].ExternalCostsMdatiqs;
        this.order.OrderYears[this.tabIndex].ExternalCostsOther = this.order.OrderYears[this.tabIndex - 1].ExternalCostsOther;
      }
      if(this.transferOptions.department.value) {
        this.order.OrderYears[this.tabIndex].BudgetField_percentage = this.order.OrderYears[this.tabIndex - 1].BudgetField_percentage;
        this.order.OrderYears[this.tabIndex].BudgetProjectManagement_percentage = this.order.OrderYears[this.tabIndex - 1].BudgetProjectManagement_percentage;
        this.order.OrderYears[this.tabIndex].BudgetQualityAssurance_percentage = this.order.OrderYears[this.tabIndex - 1].BudgetQualityAssurance_percentage;
      }
      if(this.transferOptions.address.value) {
        this.order.OrderYears[this.tabIndex].BillTo = this.order.OrderYears[this.tabIndex - 1].BillTo;
        this.order.OrderYears[this.tabIndex].BillingAddress = this.order.OrderYears[this.tabIndex - 1].BillingAddress;
        this.order.OrderYears[this.tabIndex].BillingCity = this.order.OrderYears[this.tabIndex - 1].BillingCity;
        this.order.OrderYears[this.tabIndex].BillingCountry = this.order.OrderYears[this.tabIndex - 1].BillingCountry;
        this.order.OrderYears[this.tabIndex].BillingPostalCode = this.order.OrderYears[this.tabIndex - 1].BillingPostalCode;
        this.order.OrderYears[this.tabIndex].BillingEmail = this.order.OrderYears[this.tabIndex - 1].BillingEmail;
        this.order.OrderYears[this.tabIndex].BillingEmailPaymentReminder = this.order.OrderYears[this.tabIndex - 1].BillingEmailPaymentReminder;
      }
      this.calculateBudget(this.order.OrderYears[this.tabIndex]);
      this.calculateDepartmentBudgets(this.order.OrderYears[this.tabIndex]);
      this.calculateSurveyInstancePriceMdatiqs(this.order.OrderYears[this.tabIndex]);
      this.showTransferPopup = false;
    },
    async uploadFiles(orderId) {
      const uploadPromises = this.order.OrderYears.flatMap(oy =>
        oy.Uploads.map(u => {
          if (u.UploadFile) {
            return UploadService.uploadFile(orderId, oy.Year, u.UploadFile);
          } else if(u.DataURI) {
            return UploadService.setUpload(u);
          }
        })
      );
      await Promise.all(uploadPromises);
    },
    validateOrder() {
      var isValid = false;
      // remove empty strings
      for (var prop in this.order) {
        if (Object.prototype.hasOwnProperty.call(this.order, prop)) {
          if(this.order[prop] === '') this.order[prop] = null;
        }
      }
      // validate endDate
      isValid = this.validateEndDate();
      return isValid;
    },
    validateEndDate() {
      var isValid = false;
      var startDate = new Date(Date.parse(this.order.StartDate));
      var endDate = new Date(Date.parse(this.order.EndDate));
      if(startDate > endDate) {
        this.states.inputEndDate = false;
        isValid = false;
        //scroll up to input
        document.getElementById("order-edit-popup-card-body").scrollTo({top:0, behavior:"smooth"});
        this.inputEndDateInvalidMsg = "Das Enddatum muss hinter dem Startdatum liegen."
      } else {
        this.states.inputEndDate = true;
        isValid = true;
        this.inputEndDateInvalidMsg = null;
      }
      return isValid;
    }
  },
}
</script>

<style scoped>
.popup {
  width: 80vw;
  max-height: 80vh;
  position: fixed !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
}
#order-edit-popup-form {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
#order-edit-popup-card-body {
  overflow: auto;
}
#order-edit-popup-card-footer {
  background-color: rgba(0, 0, 0, 0) !important;
}
.upload-button-container {
  position: absolute;
  z-index: 10;
  transform: translate(30%,-111%);
}
.clickable {
  cursor: pointer;
}
.disabled-color {
  color: grey;
}
.toggle-collapse {
  display: flex;
  justify-content: space-between;
}
.rotate180 {
  transform: rotate(180deg);
}
.green {
  color: green;
}
.red {
  color: red;
}
.black {
  color: black;
}
.transfer-button {
  width: 34px;
  height: 32px;
  transition: width 200ms;
  display: flex;
  align-items: center;
}
.transfer-button:hover {
  width: 240px;
}
.transfer-button .transfer-span {
  display: none;
  text-wrap-mode: nowrap;
}
.transfer-button:hover .transfer-span {
  display: block ruby;
}
@media (max-width: 999px) {
  .upload-col:not(:first-child) {
    margin-top: 1.8rem;
  }
}
</style>